(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["meyspring-faq"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('meyspring-faq')) {
  customElements.define('meyspring-faq', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.items = Array.from(this.querySelectorAll('[data-faq-item]'));
      this.groups = Array.from(this.querySelectorAll('[data-faq-group]'));
      this.input = this.querySelector('input[type="search"]');
      this.counter = this.querySelector('[data-results-count]');
      this.querySelector('[data-search]').hidden = false;
      this.input.addEventListener('input', () => this.filterQuestions());
      this.querySelectorAll('.ms-faq__topics a').forEach(link => {
        link.addEventListener('click', () => {
          if (this.input.value) {
            this.input.value = '';
            this.filterQuestions();
          }
        });
      });
      this.openHashTarget = () => {
        let hash;
        try { hash = decodeURIComponent(window.location.hash.slice(1)); } catch { return; }
        if (!hash) return;
        const target = document.getElementById(hash);
        if (!target || !this.contains(target)) return;
        const detail = target.closest('details');
        if (detail) {
          if (this.input.value) {
            this.input.value = '';
            this.filterQuestions();
          }
          detail.open = true;
        }
      };
      window.addEventListener('hashchange', this.openHashTarget);
      this.filterQuestions();
      this.openHashTarget();
    }
    disconnectedCallback() {
      if (this.openHashTarget) window.removeEventListener('hashchange', this.openHashTarget);
    }
    filterQuestions() {
      const terms = this.input.value.toLocaleLowerCase().trim().split(/\s+/).filter(Boolean);
      let count = 0;
      this.items.forEach(item => {
        const text = item.textContent.toLocaleLowerCase();
        item.hidden = !terms.every(term => text.includes(term));
        if (!item.hidden) count += 1;
      });
      this.groups.forEach(group => {
        group.hidden = !Array.from(group.querySelectorAll('[data-faq-item]')).some(item => !item.hidden);
      });
      this.querySelector('[data-empty]').hidden = count !== 0;
      this.counter.textContent = this.dataset.results.replace('[count]', count).replace('[total]', this.items.length);
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["meyspring-mobile-purchase"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ms-mobile-purchase')) {
  customElements.define('ms-mobile-purchase', class extends HTMLElement {
    connectedCallback() {
      this.main = document.getElementById(`ProductInfo-${this.dataset.sectionId}`);
      this.button = this.querySelector('button');
      if (!this.main || !this.button) return;
      this.sync = () => {
        const original = this.main.querySelector('[id^="ProductSubmitButton-"]');
        const price = this.main.querySelector('.price--on-sale .price-item--sale') || this.main.querySelector('.price__regular .price-item');
        if (!original) { this.hidden = true; return; }
        this.button.disabled = original.disabled || original.getAttribute('aria-disabled') === 'true';
        this.button.textContent = original.querySelector('span')?.textContent.trim() || original.textContent.trim();
        if (price) this.querySelector('.ms-mobile-purchase__price').textContent = price.textContent.trim();
        this.hidden = original.getBoundingClientRect().bottom >= 0;
      };
      this.activate = () => {
        const original = this.main.querySelector('[id^="ProductSubmitButton-"]');
        if (original && !this.button.disabled) {
          original.click();
          const error = this.main.querySelector('.product-form__error-message-wrapper');
          this.errorObserver?.disconnect();
          if (error) {
            this.errorObserver = new MutationObserver(() => {
              if (!error.hidden) error.scrollIntoView({ block: 'center', behavior: 'smooth' });
            });
            this.errorObserver.observe(error, { attributes: true, childList: true, subtree: true });
          }
        }
      };
      this.button.addEventListener('click', this.activate);
      this.observer = new MutationObserver(this.sync);
      this.observer.observe(this.main, { attributes: true, childList: true, subtree: true, characterData: true });
      window.addEventListener('scroll', this.sync, { passive: true });
      window.addEventListener('resize', this.sync);
      this.sync();
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.errorObserver?.disconnect();
      window.removeEventListener('scroll', this.sync);
      window.removeEventListener('resize', this.sync);
      this.button?.removeEventListener('click', this.activate);
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
